import { type CSSProperties, type ReactNode } from 'react';

interface ImgWithBackgroundProps {
    imgContent: ReactNode;
    imgDescription: string;
    color: CSSProperties['background'];
    typeColor: CSSProperties['color'];
}

export const ImgWithBackground = ({
    imgContent,
    imgDescription,
    color,
    typeColor,
}: ImgWithBackgroundProps) => (
    <div className="sds_image__container" style={{ background: color }}>
        <div>{imgContent}</div>
        <div className="sds_image__container__description" style={{ color: typeColor }}>
            {imgDescription}
        </div>
    </div>
);
